module.exports = function setUpProjectPreviews() {

  var projectLinks = document.querySelectorAll('.js-project-link');
  var preview = document.querySelector('.js-project-preview');
  var currentLink = null;
  
  if (projectLinks && preview) {
    [].forEach.call(projectLinks, function(projectLink) {
  
      projectLink.addEventListener('mouseenter', displayProjectPrevew.bind(null, projectLink));
      projectLink.addEventListener('focus', displayProjectPrevew.bind(null, projectLink));
      projectLink.addEventListener('mouseleave', hideProjectPreview);
      projectLink.addEventListener('blur', hideProjectPreview);
    });
  
  
    function displayProjectPrevew(projectLink) {
      currentLink = projectLink;

      if (window.innerWidth > 960) {
        var src = projectLink.getAttribute('data-img-src');
  
        if (src) {
          preview.setAttribute('src', src);
          preview.onload = function () {
            if (currentLink === projectLink) {
              preview.style.display = 'block';
    
              var lh = projectLink.offsetHeight;
              var lt = projectLink.getBoundingClientRect().top;
    
              var ct = projectLink.offsetParent.getBoundingClientRect().top;
              var ph = preview.offsetHeight;
    
              var wh = window.innerHeight;
    
              /**
               * Display in line with the link text, unless we are at the bottom of the
               * viewport and it would go offscreen
               */
              if (lt + 200 > wh) {
                // console.log('at bottom', ph, lh);
                preview.style.top = ((lt - ct) - ph + lh) + 'px';
              } else {
                // console.log('not at bottom');
                preview.style.top = (lt - ct) + 'px';
              }
            }

          }
  
        }
  
      }
    }

    function hideProjectPreview() {
      preview.style.display = 'none';
      currentLink = null;
    }

  }
}
